import { v4 as uuidv4 } from 'uuid';

import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { SnackbarProps } from '@/uikit/Snackbar/Snackbar';
import deleteMinuses from '@/utils/deleteMinuses';

interface Snack extends Pick<SnackbarProps, 'children' | 'variant' | 'lngKey'> {
  id: string,
}

interface ISnackState {
  snacks: Snack [],
}

export const initialState: ISnackState = {
  snacks: [],
};

export const snackSlice = createSlice({
  name: 'snack',
  initialState,
  reducers: {
    addSnack: (state, action: PayloadAction<Pick<SnackbarProps, 'children' | 'variant' | 'lngKey'>>) => {
      state.snacks = state.snacks.concat({
        ...action.payload,
        id: deleteMinuses(uuidv4()),
      });
    },
    removeSnack: (state, action: PayloadAction<string>) => {
      state.snacks = state.snacks.filter(({ id }) => id !== action.payload);
    },
  },
});

export const {
  addSnack,
  removeSnack,
} = snackSlice.actions;
export default snackSlice.reducer;
